// source: /app/Actions/Billwerk/GetCountriesFromBillwerkAction.php

export const countries = {
    "DE": {
        "code": "DE",
        "three_letter_code": "DEU",
        "name_de": "Deutschland",
        "name_en": "Germany",
        "postal_name_en": "Germany",
        "require_vat_id": false
    },
    "AT": {
        "code": "AT",
        "three_letter_code": "AUT",
        "name_de": "Österreich",
        "name_en": "Austria",
        "postal_name_en": "Austria",
        "require_vat_id": true
    },
    "CH": {
        "code": "CH",
        "three_letter_code": "CHE",
        "name_de": "Schweiz",
        "name_en": "Switzerland",
        "postal_name_en": "Switzerland",
        "require_vat_id": true
    },
    "--": {
        "code": "--",
        "three_letter_code": null,
        "name_de": "------",
        "name_en": null,
        "postal_name_en": null,
        "require_vat_id": false
    },
    "AF": {
        "code": "AF",
        "three_letter_code": "AFG",
        "name_de": "Afghanistan",
        "name_en": "Afghanistan",
        "postal_name_en": "Afghanistan",
        "require_vat_id": false
    },
    "AX": {
        "code": "AX",
        "three_letter_code": "ALA",
        "name_de": "Åland Inseln",
        "name_en": "Åland Islands",
        "postal_name_en": "Aland",
        "require_vat_id": false
    },
    "AL": {
        "code": "AL",
        "three_letter_code": "ALB",
        "name_de": "Albanien",
        "name_en": "Albania",
        "postal_name_en": "Albania",
        "require_vat_id": false
    },
    "DZ": {
        "code": "DZ",
        "three_letter_code": "DZA",
        "name_de": "Algerien",
        "name_en": "Algeria",
        "postal_name_en": "Algeria",
        "require_vat_id": false
    },
    "AS": {
        "code": "AS",
        "three_letter_code": "ASM",
        "name_de": "Amerikanisch Samoa",
        "name_en": "American Samoa",
        "postal_name_en": "American Samoa",
        "require_vat_id": false
    },
    "AD": {
        "code": "AD",
        "three_letter_code": "AND",
        "name_de": "Andorra",
        "name_en": "Andorra",
        "postal_name_en": "Andorra",
        "require_vat_id": false
    },
    "AO": {
        "code": "AO",
        "three_letter_code": "AGO",
        "name_de": "Angola",
        "name_en": "Angola",
        "postal_name_en": "Angola",
        "require_vat_id": false
    },
    "AI": {
        "code": "AI",
        "three_letter_code": "AIA",
        "name_de": "Anguilla",
        "name_en": "Anguilla",
        "postal_name_en": "Anguilla",
        "require_vat_id": false
    },
    "AQ": {
        "code": "AQ",
        "three_letter_code": "ATA",
        "name_de": "Antarktis",
        "name_en": "Antarctica",
        "postal_name_en": "Antarctica",
        "require_vat_id": false
    },
    "AG": {
        "code": "AG",
        "three_letter_code": "ATG",
        "name_de": "Antigua und Barbuda",
        "name_en": "Antigua and Barbuda",
        "postal_name_en": "Antigua and Barbuda",
        "require_vat_id": false
    },
    "AR": {
        "code": "AR",
        "three_letter_code": "ARG",
        "name_de": "Argentinien",
        "name_en": "Argentina",
        "postal_name_en": "Argentina",
        "require_vat_id": false
    },
    "AM": {
        "code": "AM",
        "three_letter_code": "ARM",
        "name_de": "Armenien",
        "name_en": "Armenia",
        "postal_name_en": "Armenia",
        "require_vat_id": false
    },
    "AW": {
        "code": "AW",
        "three_letter_code": "ABW",
        "name_de": "Aruba",
        "name_en": "Aruba",
        "postal_name_en": "Aruba",
        "require_vat_id": false
    },
    "AU": {
        "code": "AU",
        "three_letter_code": "AUS",
        "name_de": "Australien",
        "name_en": "Australia",
        "postal_name_en": "Australia",
        "require_vat_id": false
    },
    "AZ": {
        "code": "AZ",
        "three_letter_code": "AZE",
        "name_de": "Aserbaidschan",
        "name_en": "Azerbaijan",
        "postal_name_en": "Azerbaijan",
        "require_vat_id": false
    },
    "BS": {
        "code": "BS",
        "three_letter_code": "BHS",
        "name_de": "Bahamas",
        "name_en": "Bahamas",
        "postal_name_en": "Bahamas",
        "require_vat_id": false
    },
    "BH": {
        "code": "BH",
        "three_letter_code": "BHR",
        "name_de": "Bahrain",
        "name_en": "Bahrain",
        "postal_name_en": "Bahrain",
        "require_vat_id": false
    },
    "BD": {
        "code": "BD",
        "three_letter_code": "BGD",
        "name_de": "Bangladesch",
        "name_en": "Bangladesh",
        "postal_name_en": "Bangladesch",
        "require_vat_id": false
    },
    "BB": {
        "code": "BB",
        "three_letter_code": "BRB",
        "name_de": "Barbados",
        "name_en": "Barbados",
        "postal_name_en": "Barbados",
        "require_vat_id": false
    },
    "BY": {
        "code": "BY",
        "three_letter_code": "BLR",
        "name_de": "Weißrussland",
        "name_en": "Belarus",
        "postal_name_en": "Belarus",
        "require_vat_id": false
    },
    "BE": {
        "code": "BE",
        "three_letter_code": "BEL",
        "name_de": "Belgien",
        "name_en": "Belgium",
        "postal_name_en": "Belgium",
        "require_vat_id": true
    },
    "BZ": {
        "code": "BZ",
        "three_letter_code": "BLZ",
        "name_de": "Belize",
        "name_en": "Belize",
        "postal_name_en": "Belize",
        "require_vat_id": false
    },
    "BJ": {
        "code": "BJ",
        "three_letter_code": "BEN",
        "name_de": "Benin",
        "name_en": "Benin",
        "postal_name_en": "Benin",
        "require_vat_id": false
    },
    "BM": {
        "code": "BM",
        "three_letter_code": "BMU",
        "name_de": "Bermuda",
        "name_en": "Bermuda",
        "postal_name_en": "Bermuda",
        "require_vat_id": false
    },
    "BT": {
        "code": "BT",
        "three_letter_code": "BTN",
        "name_de": "Bhutan",
        "name_en": "Bhutan",
        "postal_name_en": "Bhutan",
        "require_vat_id": false
    },
    "BO": {
        "code": "BO",
        "three_letter_code": "BOL",
        "name_de": "Bolivien",
        "name_en": "Bolivia, Plurinational State of",
        "postal_name_en": "Bolivia",
        "require_vat_id": false
    },
    "BQ": {
        "code": "BQ",
        "three_letter_code": "BES",
        "name_de": "Bonaire, Saba und Sint Eustatius",
        "name_en": "Bonaire, Sint Eustatius and Saba",
        "postal_name_en": "Netherlands Antilles",
        "require_vat_id": false
    },
    "BA": {
        "code": "BA",
        "three_letter_code": "BIH",
        "name_de": "Bosnien und Herzegowina",
        "name_en": "Bosnia and Herzegovina",
        "postal_name_en": "Bosnia and Herzegovina",
        "require_vat_id": false
    },
    "BW": {
        "code": "BW",
        "three_letter_code": "BWA",
        "name_de": "Botsuana",
        "name_en": "Botswana",
        "postal_name_en": "Botswana",
        "require_vat_id": false
    },
    "BV": {
        "code": "BV",
        "three_letter_code": "BVT",
        "name_de": "Bouvetinsel",
        "name_en": "Bouvet Island",
        "postal_name_en": "Bouvet Island",
        "require_vat_id": false
    },
    "BR": {
        "code": "BR",
        "three_letter_code": "BRA",
        "name_de": "Brasilien",
        "name_en": "Brazil",
        "postal_name_en": "Brazil",
        "require_vat_id": false
    },
    "IO": {
        "code": "IO",
        "three_letter_code": "IOT",
        "name_de": "Britische Territorien im Indischen Ozean",
        "name_en": "British Indian Ocean Territory",
        "postal_name_en": "British Indian Ocean Territory",
        "require_vat_id": false
    },
    "BN": {
        "code": "BN",
        "three_letter_code": "BRN",
        "name_de": "Brunei Darussalam",
        "name_en": "Brunei Darussalam",
        "postal_name_en": "Brunei",
        "require_vat_id": false
    },
    "BG": {
        "code": "BG",
        "three_letter_code": "BGR",
        "name_de": "Bulgarien",
        "name_en": "Bulgaria",
        "postal_name_en": "Bulgaria",
        "require_vat_id": true
    },
    "BF": {
        "code": "BF",
        "three_letter_code": "BFA",
        "name_de": "Burkina Faso",
        "name_en": "Burkina Faso",
        "postal_name_en": "Burkina Faso",
        "require_vat_id": false
    },
    "BI": {
        "code": "BI",
        "three_letter_code": "BDI",
        "name_de": "Burundi",
        "name_en": "Burundi",
        "postal_name_en": "Burundi",
        "require_vat_id": false
    },
    "KH": {
        "code": "KH",
        "three_letter_code": "KHM",
        "name_de": "Kambodscha",
        "name_en": "Cambodia",
        "postal_name_en": "Cambodia",
        "require_vat_id": false
    },
    "CM": {
        "code": "CM",
        "three_letter_code": "CMR",
        "name_de": "Kamerun",
        "name_en": "Cameroon",
        "postal_name_en": "Cameroon",
        "require_vat_id": false
    },
    "CA": {
        "code": "CA",
        "three_letter_code": "CAN",
        "name_de": "Kanada",
        "name_en": "Canada",
        "postal_name_en": "Canada",
        "require_vat_id": false
    },
    "IC": {
        "code": "IC",
        "three_letter_code": null,
        "name_de": "Kanarische Inseln",
        "name_en": "Canary Islands",
        "postal_name_en": "Canary Islands",
        "require_vat_id": false
    },
    "CV": {
        "code": "CV",
        "three_letter_code": "CPV",
        "name_de": "Kap Verde",
        "name_en": "Cape Verde",
        "postal_name_en": "Cape Verde",
        "require_vat_id": false
    },
    "KY": {
        "code": "KY",
        "three_letter_code": "CYM",
        "name_de": "Kaimaninseln",
        "name_en": "Cayman Islands",
        "postal_name_en": "Cayman Islands",
        "require_vat_id": false
    },
    "CF": {
        "code": "CF",
        "three_letter_code": "CAF",
        "name_de": "Zentralafrikanische Republik",
        "name_en": "Central African Republic",
        "postal_name_en": "Central African Republic",
        "require_vat_id": false
    },
    "TD": {
        "code": "TD",
        "three_letter_code": "TCD",
        "name_de": "Tschad",
        "name_en": "Chad",
        "postal_name_en": "Chad",
        "require_vat_id": false
    },
    "CL": {
        "code": "CL",
        "three_letter_code": "CHL",
        "name_de": "Chile",
        "name_en": "Chile",
        "postal_name_en": "Chile",
        "require_vat_id": false
    },
    "CN": {
        "code": "CN",
        "three_letter_code": "CHN",
        "name_de": "China",
        "name_en": "China",
        "postal_name_en": "China",
        "require_vat_id": false
    },
    "CX": {
        "code": "CX",
        "three_letter_code": "CXR",
        "name_de": "Weihnachtsinsel",
        "name_en": "Christmas Island",
        "postal_name_en": "Christmas Islands",
        "require_vat_id": false
    },
    "CC": {
        "code": "CC",
        "three_letter_code": "CCK",
        "name_de": "Kokosinseln",
        "name_en": "Cocos (Keeling) Islands",
        "postal_name_en": "Cocos (Keeling) Islands",
        "require_vat_id": false
    },
    "CO": {
        "code": "CO",
        "three_letter_code": "COL",
        "name_de": "Kolumbien",
        "name_en": "Colombia",
        "postal_name_en": "Colombia",
        "require_vat_id": false
    },
    "KM": {
        "code": "KM",
        "three_letter_code": "COM",
        "name_de": "Komoren",
        "name_en": "Comoros",
        "postal_name_en": "Comoros",
        "require_vat_id": false
    },
    "CG": {
        "code": "CG",
        "three_letter_code": "COG",
        "name_de": "Kongo",
        "name_en": "Congo",
        "postal_name_en": "Republic of the Congo",
        "require_vat_id": false
    },
    "CD": {
        "code": "CD",
        "three_letter_code": "COD",
        "name_de": "Kongo, Dem. Rep.",
        "name_en": "Congo, The Democratic Republic of the",
        "postal_name_en": "Democratic Republic of the Congo",
        "require_vat_id": false
    },
    "CK": {
        "code": "CK",
        "three_letter_code": "COK",
        "name_de": "Cookinseln",
        "name_en": "Cook Islands",
        "postal_name_en": "Cook Islands",
        "require_vat_id": false
    },
    "CR": {
        "code": "CR",
        "three_letter_code": "CRI",
        "name_de": "Costa Rica",
        "name_en": "Costa Rica",
        "postal_name_en": "Costa Rica",
        "require_vat_id": false
    },
    "CI": {
        "code": "CI",
        "three_letter_code": "CIV",
        "name_de": "Côte d´Ivoire",
        "name_en": "Côte d´Ivoire",
        "postal_name_en": "Cote d´Ivoire",
        "require_vat_id": false
    },
    "HR": {
        "code": "HR",
        "three_letter_code": "HRV",
        "name_de": "Kroatien",
        "name_en": "Croatia",
        "postal_name_en": "Croatia",
        "require_vat_id": true
    },
    "CU": {
        "code": "CU",
        "three_letter_code": "CUB",
        "name_de": "Kuba",
        "name_en": "Cuba",
        "postal_name_en": "Cuba",
        "require_vat_id": false
    },
    "CW": {
        "code": "CW",
        "three_letter_code": "CUW",
        "name_de": "Curaçao",
        "name_en": "Curaçao",
        "postal_name_en": "Netherlands Antilles",
        "require_vat_id": false
    },
    "CY": {
        "code": "CY",
        "three_letter_code": "CYP",
        "name_de": "Zypern",
        "name_en": "Cyprus",
        "postal_name_en": "Cyprus",
        "require_vat_id": true
    },
    "CZ": {
        "code": "CZ",
        "three_letter_code": "CZE",
        "name_de": "Tschechische Republik",
        "name_en": "Czech Republic",
        "postal_name_en": "Czech Republic",
        "require_vat_id": true
    },
    "DK": {
        "code": "DK",
        "three_letter_code": "DNK",
        "name_de": "Dänemark",
        "name_en": "Denmark",
        "postal_name_en": "Denmark",
        "require_vat_id": true
    },
    "DJ": {
        "code": "DJ",
        "three_letter_code": "DJI",
        "name_de": "Republik Dschibuti",
        "name_en": "Djibouti",
        "postal_name_en": "Djibouti",
        "require_vat_id": false
    },
    "DM": {
        "code": "DM",
        "three_letter_code": "DMA",
        "name_de": "Dominica",
        "name_en": "Dominica",
        "postal_name_en": "Dominica",
        "require_vat_id": false
    },
    "DO": {
        "code": "DO",
        "three_letter_code": "DOM",
        "name_de": "Dominikanische Republik",
        "name_en": "Dominican Republic",
        "postal_name_en": "Dominican Republic",
        "require_vat_id": false
    },
    "EC": {
        "code": "EC",
        "three_letter_code": "ECU",
        "name_de": "Ecuador",
        "name_en": "Ecuador",
        "postal_name_en": "Ecuador",
        "require_vat_id": false
    },
    "EG": {
        "code": "EG",
        "three_letter_code": "EGY",
        "name_de": "Ägypten",
        "name_en": "Egypt",
        "postal_name_en": "Egypt",
        "require_vat_id": false
    },
    "SV": {
        "code": "SV",
        "three_letter_code": "SLV",
        "name_de": "El Salvador",
        "name_en": "El Salvador",
        "postal_name_en": "El Salvador",
        "require_vat_id": false
    },
    "GQ": {
        "code": "GQ",
        "three_letter_code": "GNQ",
        "name_de": "Äquatorialguinea",
        "name_en": "Equatorial Guinea",
        "postal_name_en": "Equatorial Guinea",
        "require_vat_id": false
    },
    "ER": {
        "code": "ER",
        "three_letter_code": "ERI",
        "name_de": "Eritrea",
        "name_en": "Eritrea",
        "postal_name_en": "Eritrea",
        "require_vat_id": false
    },
    "EE": {
        "code": "EE",
        "three_letter_code": "EST",
        "name_de": "Estland",
        "name_en": "Estonia",
        "postal_name_en": "Estonia",
        "require_vat_id": true
    },
    "ET": {
        "code": "ET",
        "three_letter_code": "ETH",
        "name_de": "Äthiopien",
        "name_en": "Ethiopia",
        "postal_name_en": "Ethiopia",
        "require_vat_id": false
    },
    "FK": {
        "code": "FK",
        "three_letter_code": "FLK",
        "name_de": "Falklandinseln",
        "name_en": "Falkland Islands (Malvinas)",
        "postal_name_en": "Falkland Islands",
        "require_vat_id": false
    },
    "FO": {
        "code": "FO",
        "three_letter_code": "FRO",
        "name_de": "Färöer",
        "name_en": "Faroe Islands",
        "postal_name_en": "Faroe Islands",
        "require_vat_id": false
    },
    "FJ": {
        "code": "FJ",
        "three_letter_code": "FJI",
        "name_de": "Fidschi",
        "name_en": "Fiji",
        "postal_name_en": "Fiji",
        "require_vat_id": false
    },
    "FI": {
        "code": "FI",
        "three_letter_code": "FIN",
        "name_de": "Finnland",
        "name_en": "Finland",
        "postal_name_en": "Finland",
        "require_vat_id": true
    },
    "FR": {
        "code": "FR",
        "three_letter_code": "FRA",
        "name_de": "Frankreich",
        "name_en": "France",
        "postal_name_en": "France",
        "require_vat_id": true
    },
    "GF": {
        "code": "GF",
        "three_letter_code": "GUF",
        "name_de": "Französisch Guiana",
        "name_en": "French Guiana",
        "postal_name_en": "Französisch-Guyana",
        "require_vat_id": false
    },
    "PF": {
        "code": "PF",
        "three_letter_code": "PYF",
        "name_de": "Französisch Polynesien",
        "name_en": "French Polynesia",
        "postal_name_en": "Französisch-Polynesien",
        "require_vat_id": false
    },
    "TF": {
        "code": "TF",
        "three_letter_code": "ATF",
        "name_de": "Französische Südgebiete",
        "name_en": "French Southern Territories",
        "postal_name_en": "French Southern Territories",
        "require_vat_id": false
    },
    "GA": {
        "code": "GA",
        "three_letter_code": "GAB",
        "name_de": "Gabun",
        "name_en": "Gabon",
        "postal_name_en": "Gabon",
        "require_vat_id": false
    },
    "GM": {
        "code": "GM",
        "three_letter_code": "GMB",
        "name_de": "Gambia",
        "name_en": "Gambia",
        "postal_name_en": "Gambia",
        "require_vat_id": false
    },
    "GE": {
        "code": "GE",
        "three_letter_code": "GEO",
        "name_de": "Georgien",
        "name_en": "Georgia",
        "postal_name_en": "Georgia",
        "require_vat_id": false
    },
    "GH": {
        "code": "GH",
        "three_letter_code": "GHA",
        "name_de": "Ghana",
        "name_en": "Ghana",
        "postal_name_en": "Ghana",
        "require_vat_id": false
    },
    "GI": {
        "code": "GI",
        "three_letter_code": "GIB",
        "name_de": "Gibraltar",
        "name_en": "Gibraltar",
        "postal_name_en": "Gibraltar",
        "require_vat_id": false
    },
    "GR": {
        "code": "GR",
        "three_letter_code": "GRC",
        "name_de": "Griechenland",
        "name_en": "Greece",
        "postal_name_en": "Greece",
        "require_vat_id": false
    },
    "GL": {
        "code": "GL",
        "three_letter_code": "GRL",
        "name_de": "Grönland",
        "name_en": "Greenland",
        "postal_name_en": "Greenland",
        "require_vat_id": false
    },
    "GD": {
        "code": "GD",
        "three_letter_code": "GRD",
        "name_de": "Grenada",
        "name_en": "Grenada",
        "postal_name_en": "Grenada",
        "require_vat_id": false
    },
    "GP": {
        "code": "GP",
        "three_letter_code": "GLP",
        "name_de": "Guadeloupe",
        "name_en": "Guadeloupe",
        "postal_name_en": "Guadeloupe",
        "require_vat_id": false
    },
    "GU": {
        "code": "GU",
        "three_letter_code": "GUM",
        "name_de": "Guam",
        "name_en": "Guam",
        "postal_name_en": "Guam",
        "require_vat_id": false
    },
    "GT": {
        "code": "GT",
        "three_letter_code": "GTM",
        "name_de": "Guatemala",
        "name_en": "Guatemala",
        "postal_name_en": "Guatemala",
        "require_vat_id": false
    },
    "GG": {
        "code": "GG",
        "three_letter_code": "GGY",
        "name_de": "Guernsey",
        "name_en": "Guernsey",
        "postal_name_en": "Guernsey",
        "require_vat_id": false
    },
    "GN": {
        "code": "GN",
        "three_letter_code": "GIN",
        "name_de": "Guinea",
        "name_en": "Guinea",
        "postal_name_en": "Guinea",
        "require_vat_id": false
    },
    "GW": {
        "code": "GW",
        "three_letter_code": "GNB",
        "name_de": "Guinea-Bissau",
        "name_en": "Guinea-Bissau",
        "postal_name_en": "Guinea-Bissau",
        "require_vat_id": false
    },
    "GY": {
        "code": "GY",
        "three_letter_code": "GUY",
        "name_de": "Guyana",
        "name_en": "Guyana",
        "postal_name_en": "Guyana",
        "require_vat_id": false
    },
    "HT": {
        "code": "HT",
        "three_letter_code": "HTI",
        "name_de": "Haiti",
        "name_en": "Haiti",
        "postal_name_en": "Haiti",
        "require_vat_id": false
    },
    "HM": {
        "code": "HM",
        "three_letter_code": "HMD",
        "name_de": "Heard Insel und McDonald Inseln",
        "name_en": "Heard Island and McDonald Islands",
        "postal_name_en": "Heard Island and McDonald Islands",
        "require_vat_id": false
    },
    "VA": {
        "code": "VA",
        "three_letter_code": "VAT",
        "name_de": "Heiliger Stuhl",
        "name_en": "Holy See (Vatican City State)",
        "postal_name_en": "Vatican",
        "require_vat_id": false
    },
    "HN": {
        "code": "HN",
        "three_letter_code": "HND",
        "name_de": "Honduras",
        "name_en": "Honduras",
        "postal_name_en": "Honduras",
        "require_vat_id": false
    },
    "HK": {
        "code": "HK",
        "three_letter_code": "HKG",
        "name_de": "Hong Kong",
        "name_en": "Hong Kong",
        "postal_name_en": "Hongkong",
        "require_vat_id": false
    },
    "HU": {
        "code": "HU",
        "three_letter_code": "HUN",
        "name_de": "Ungarn",
        "name_en": "Hungary",
        "postal_name_en": "Hungary",
        "require_vat_id": true
    },
    "IS": {
        "code": "IS",
        "three_letter_code": "ISL",
        "name_de": "Island",
        "name_en": "Iceland",
        "postal_name_en": "Iceland",
        "require_vat_id": true
    },
    "IN": {
        "code": "IN",
        "three_letter_code": "IND",
        "name_de": "Indien",
        "name_en": "India",
        "postal_name_en": "India",
        "require_vat_id": false
    },
    "ID": {
        "code": "ID",
        "three_letter_code": "IDN",
        "name_de": "Indonesien",
        "name_en": "Indonesia",
        "postal_name_en": "Indonesia",
        "require_vat_id": false
    },
    "IR": {
        "code": "IR",
        "three_letter_code": "IRN",
        "name_de": "Iran, Islam. Rep.",
        "name_en": "Iran, Islamic Republic of",
        "postal_name_en": "Iran",
        "require_vat_id": false
    },
    "IQ": {
        "code": "IQ",
        "three_letter_code": "IRQ",
        "name_de": "Irak",
        "name_en": "Iraq",
        "postal_name_en": "Iraq",
        "require_vat_id": false
    },
    "IE": {
        "code": "IE",
        "three_letter_code": "IRL",
        "name_de": "Irland",
        "name_en": "Ireland",
        "postal_name_en": "Ireland",
        "require_vat_id": true
    },
    "IM": {
        "code": "IM",
        "three_letter_code": "IMN",
        "name_de": "Isle of Man",
        "name_en": "Isle of Man",
        "postal_name_en": "Isle of Man",
        "require_vat_id": false
    },
    "IL": {
        "code": "IL",
        "three_letter_code": "ISR",
        "name_de": "Israel",
        "name_en": "Israel",
        "postal_name_en": "Israel",
        "require_vat_id": false
    },
    "IT": {
        "code": "IT",
        "three_letter_code": "ITA",
        "name_de": "Italien",
        "name_en": "Italy",
        "postal_name_en": "Italy",
        "require_vat_id": true
    },
    "JM": {
        "code": "JM",
        "three_letter_code": "JAM",
        "name_de": "Jamaika",
        "name_en": "Jamaica",
        "postal_name_en": "Jamaica",
        "require_vat_id": false
    },
    "JP": {
        "code": "JP",
        "three_letter_code": "JPN",
        "name_de": "Japan",
        "name_en": "Japan",
        "postal_name_en": "Japan",
        "require_vat_id": false
    },
    "JE": {
        "code": "JE",
        "three_letter_code": "JEY",
        "name_de": "Jersey",
        "name_en": "Jersey",
        "postal_name_en": "Jersey",
        "require_vat_id": false
    },
    "JO": {
        "code": "JO",
        "three_letter_code": "JOR",
        "name_de": "Jordanien",
        "name_en": "Jordan",
        "postal_name_en": "Jordan",
        "require_vat_id": false
    },
    "KZ": {
        "code": "KZ",
        "three_letter_code": "KAZ",
        "name_de": "Kasachstan",
        "name_en": "Kazakhstan",
        "postal_name_en": "Kazakhstan",
        "require_vat_id": false
    },
    "KE": {
        "code": "KE",
        "three_letter_code": "KEN",
        "name_de": "Kenia",
        "name_en": "Kenya",
        "postal_name_en": "Kenya",
        "require_vat_id": false
    },
    "KI": {
        "code": "KI",
        "three_letter_code": "KIR",
        "name_de": "Kiribati",
        "name_en": "Kiribati",
        "postal_name_en": "Kiribati",
        "require_vat_id": false
    },
    "KP": {
        "code": "KP",
        "three_letter_code": "PRK",
        "name_de": "Korea, Dem. Volksrep.",
        "name_en": "Korea, Democratic People's Republic of",
        "postal_name_en": "North Korea",
        "require_vat_id": false
    },
    "KR": {
        "code": "KR",
        "three_letter_code": "KOR",
        "name_de": "Korea, Rep.",
        "name_en": "Korea, Republic of",
        "postal_name_en": "South Korea",
        "require_vat_id": false
    },
    "XK": {
        "code": "XK",
        "three_letter_code": null,
        "name_de": "Kosovo",
        "name_en": "Kosovo",
        "postal_name_en": "Kosovo",
        "require_vat_id": false
    },
    "KW": {
        "code": "KW",
        "three_letter_code": "KWT",
        "name_de": "Kuwait",
        "name_en": "Kuwait",
        "postal_name_en": "Kuwait",
        "require_vat_id": false
    },
    "KG": {
        "code": "KG",
        "three_letter_code": "KGZ",
        "name_de": "Kirgisistan",
        "name_en": "Kyrgyzstan",
        "postal_name_en": "Kirgistan",
        "require_vat_id": false
    },
    "LA": {
        "code": "LA",
        "three_letter_code": "LAO",
        "name_de": "Laos, Dem. Volksrep.",
        "name_en": "Lao People's Democratic Republic",
        "postal_name_en": "Laos",
        "require_vat_id": false
    },
    "LV": {
        "code": "LV",
        "three_letter_code": "LVA",
        "name_de": "Lettland",
        "name_en": "Latvia",
        "postal_name_en": "Latvia",
        "require_vat_id": true
    },
    "LB": {
        "code": "LB",
        "three_letter_code": "LBN",
        "name_de": "Libanon",
        "name_en": "Lebanon",
        "postal_name_en": "Lebanon",
        "require_vat_id": false
    },
    "LS": {
        "code": "LS",
        "three_letter_code": "LSO",
        "name_de": "Lesotho",
        "name_en": "Lesotho",
        "postal_name_en": "Lesotho",
        "require_vat_id": false
    },
    "LR": {
        "code": "LR",
        "three_letter_code": "LBR",
        "name_de": "Liberia",
        "name_en": "Liberia",
        "postal_name_en": "Liberia",
        "require_vat_id": false
    },
    "LY": {
        "code": "LY",
        "three_letter_code": "LBY",
        "name_de": "Libysch-Arabische Dschamahirija",
        "name_en": "Libya",
        "postal_name_en": "Libya",
        "require_vat_id": false
    },
    "LI": {
        "code": "LI",
        "three_letter_code": "LIE",
        "name_de": "Liechtenstein",
        "name_en": "Liechtenstein",
        "postal_name_en": "Liechtenstein",
        "require_vat_id": false
    },
    "LT": {
        "code": "LT",
        "three_letter_code": "LTU",
        "name_de": "Litauen",
        "name_en": "Lithuania",
        "postal_name_en": "Lithuania",
        "require_vat_id": true
    },
    "LU": {
        "code": "LU",
        "three_letter_code": "LUX",
        "name_de": "Luxemburg",
        "name_en": "Luxembourg",
        "postal_name_en": "Luxembourg",
        "require_vat_id": true
    },
    "MO": {
        "code": "MO",
        "three_letter_code": "MAC",
        "name_de": "Macao",
        "name_en": "Macao",
        "postal_name_en": "Macao",
        "require_vat_id": false
    },
    "MK": {
        "code": "MK",
        "three_letter_code": "MKD",
        "name_de": "Mazedonien, ehemalige jugoslawische Republik",
        "name_en": "Macedonia, The Former Yugoslav Republic of",
        "postal_name_en": "Macedonia",
        "require_vat_id": false
    },
    "MG": {
        "code": "MG",
        "three_letter_code": "MDG",
        "name_de": "Madagaskar",
        "name_en": "Madagascar",
        "postal_name_en": "Madagascar",
        "require_vat_id": false
    },
    "MW": {
        "code": "MW",
        "three_letter_code": "MWI",
        "name_de": "Malawi",
        "name_en": "Malawi",
        "postal_name_en": "Malawi",
        "require_vat_id": false
    },
    "MY": {
        "code": "MY",
        "three_letter_code": "MYS",
        "name_de": "Malaysia",
        "name_en": "Malaysia",
        "postal_name_en": "Malaysia",
        "require_vat_id": false
    },
    "MV": {
        "code": "MV",
        "three_letter_code": "MDV",
        "name_de": "Malediven",
        "name_en": "Maldives",
        "postal_name_en": "Maldives",
        "require_vat_id": false
    },
    "ML": {
        "code": "ML",
        "three_letter_code": "MLI",
        "name_de": "Mali",
        "name_en": "Mali",
        "postal_name_en": "Mali",
        "require_vat_id": false
    },
    "MT": {
        "code": "MT",
        "three_letter_code": "MLT",
        "name_de": "Malta",
        "name_en": "Malta",
        "postal_name_en": "Malta",
        "require_vat_id": true
    },
    "MH": {
        "code": "MH",
        "three_letter_code": "MHL",
        "name_de": "Marshallinseln",
        "name_en": "Marshall Islands",
        "postal_name_en": "Marshall Islands",
        "require_vat_id": false
    },
    "MQ": {
        "code": "MQ",
        "three_letter_code": "MTQ",
        "name_de": "Martinique",
        "name_en": "Martinique",
        "postal_name_en": "Martinique",
        "require_vat_id": false
    },
    "MR": {
        "code": "MR",
        "three_letter_code": "MRT",
        "name_de": "Mauretanien",
        "name_en": "Mauritania",
        "postal_name_en": "Mauritania",
        "require_vat_id": false
    },
    "MU": {
        "code": "MU",
        "three_letter_code": "MUS",
        "name_de": "Mauritius",
        "name_en": "Mauritius",
        "postal_name_en": "Mauritius",
        "require_vat_id": false
    },
    "YT": {
        "code": "YT",
        "three_letter_code": "MYT",
        "name_de": "Mayotte",
        "name_en": "Mayotte",
        "postal_name_en": "Mayotte",
        "require_vat_id": false
    },
    "MX": {
        "code": "MX",
        "three_letter_code": "MEX",
        "name_de": "Mexiko",
        "name_en": "Mexico",
        "postal_name_en": "Mexico",
        "require_vat_id": false
    },
    "FM": {
        "code": "FM",
        "three_letter_code": "FSM",
        "name_de": "Mikronesien, Föderierte Staaten von",
        "name_en": "Micronesia, Federated States of",
        "postal_name_en": "Micronesia",
        "require_vat_id": false
    },
    "MD": {
        "code": "MD",
        "three_letter_code": "MDA",
        "name_de": "Moldau, Rep.",
        "name_en": "Moldova, Republic of",
        "postal_name_en": "Moldova",
        "require_vat_id": false
    },
    "MC": {
        "code": "MC",
        "three_letter_code": "MCO",
        "name_de": "Monaco",
        "name_en": "Monaco",
        "postal_name_en": "Monaco",
        "require_vat_id": false
    },
    "MN": {
        "code": "MN",
        "three_letter_code": "MNG",
        "name_de": "Mongolei",
        "name_en": "Mongolia",
        "postal_name_en": "Mongolia",
        "require_vat_id": false
    },
    "ME": {
        "code": "ME",
        "three_letter_code": "MNE",
        "name_de": "Montenegro",
        "name_en": "Montenegro",
        "postal_name_en": "Montenegro",
        "require_vat_id": false
    },
    "MS": {
        "code": "MS",
        "three_letter_code": "MSR",
        "name_de": "Montserrat",
        "name_en": "Montserrat",
        "postal_name_en": "Montserrat",
        "require_vat_id": false
    },
    "MA": {
        "code": "MA",
        "three_letter_code": "MAR",
        "name_de": "Marokko",
        "name_en": "Morocco",
        "postal_name_en": "Morocco",
        "require_vat_id": false
    },
    "MZ": {
        "code": "MZ",
        "three_letter_code": "MOZ",
        "name_de": "Mosambik",
        "name_en": "Mozambique",
        "postal_name_en": "Mozambique",
        "require_vat_id": false
    },
    "MM": {
        "code": "MM",
        "three_letter_code": "MMR",
        "name_de": "Myanmar",
        "name_en": "Myanmar",
        "postal_name_en": "Myanmar",
        "require_vat_id": false
    },
    "NA": {
        "code": "NA",
        "three_letter_code": "NAM",
        "name_de": "Namibia",
        "name_en": "Namibia",
        "postal_name_en": "Namibia",
        "require_vat_id": false
    },
    "NR": {
        "code": "NR",
        "three_letter_code": "NRU",
        "name_de": "Nauru",
        "name_en": "Nauru",
        "postal_name_en": "Nauru",
        "require_vat_id": false
    },
    "NP": {
        "code": "NP",
        "three_letter_code": "NPL",
        "name_de": "Nepal",
        "name_en": "Nepal",
        "postal_name_en": "Nepal",
        "require_vat_id": false
    },
    "NL": {
        "code": "NL",
        "three_letter_code": "NLD",
        "name_de": "Niederlande",
        "name_en": "Netherlands",
        "postal_name_en": "Netherlands",
        "require_vat_id": true
    },
    "NC": {
        "code": "NC",
        "three_letter_code": "NCL",
        "name_de": "Neukaledonien",
        "name_en": "New Caledonia",
        "postal_name_en": "New Caledonia",
        "require_vat_id": false
    },
    "NZ": {
        "code": "NZ",
        "three_letter_code": "NZL",
        "name_de": "Neuseeland",
        "name_en": "New Zealand",
        "postal_name_en": "New Zealand",
        "require_vat_id": false
    },
    "NI": {
        "code": "NI",
        "three_letter_code": "NIC",
        "name_de": "Nicaragua",
        "name_en": "Nicaragua",
        "postal_name_en": "Nicaragua",
        "require_vat_id": false
    },
    "NE": {
        "code": "NE",
        "three_letter_code": "NER",
        "name_de": "Niger",
        "name_en": "Niger",
        "postal_name_en": "Niger",
        "require_vat_id": false
    },
    "NG": {
        "code": "NG",
        "three_letter_code": "NGA",
        "name_de": "Nigeria",
        "name_en": "Nigeria",
        "postal_name_en": "Nigeria",
        "require_vat_id": false
    },
    "NU": {
        "code": "NU",
        "three_letter_code": "NIU",
        "name_de": "Niue",
        "name_en": "Niue",
        "postal_name_en": "Niue",
        "require_vat_id": false
    },
    "NF": {
        "code": "NF",
        "three_letter_code": "NFK",
        "name_de": "Norfolk Insel",
        "name_en": "Norfolk Island",
        "postal_name_en": "Norfolk Islands",
        "require_vat_id": false
    },
    "MP": {
        "code": "MP",
        "three_letter_code": "MNP",
        "name_de": "Nördliche Marianen",
        "name_en": "Northern Mariana Islands",
        "postal_name_en": "Mariana Islands",
        "require_vat_id": false
    },
    "NO": {
        "code": "NO",
        "three_letter_code": "NOR",
        "name_de": "Norwegen",
        "name_en": "Norway",
        "postal_name_en": "Norway",
        "require_vat_id": true
    },
    "OM": {
        "code": "OM",
        "three_letter_code": "OMN",
        "name_de": "Oman",
        "name_en": "Oman",
        "postal_name_en": "Oman",
        "require_vat_id": false
    },
    "PK": {
        "code": "PK",
        "three_letter_code": "PAK",
        "name_de": "Pakistan",
        "name_en": "Pakistan",
        "postal_name_en": "Pakistan",
        "require_vat_id": false
    },
    "PW": {
        "code": "PW",
        "three_letter_code": "PLW",
        "name_de": "Palau",
        "name_en": "Palau",
        "postal_name_en": "Palau",
        "require_vat_id": false
    },
    "PS": {
        "code": "PS",
        "three_letter_code": "PSE",
        "name_de": "Palästinische Gebiete",
        "name_en": "Palestine, State of",
        "postal_name_en": "Palestine",
        "require_vat_id": false
    },
    "PA": {
        "code": "PA",
        "three_letter_code": "PAN",
        "name_de": "Panama",
        "name_en": "Panama",
        "postal_name_en": "Panama",
        "require_vat_id": false
    },
    "PG": {
        "code": "PG",
        "three_letter_code": "PNG",
        "name_de": "Papua-Neuguinea",
        "name_en": "Papua New Guinea",
        "postal_name_en": "Papua New Guinea",
        "require_vat_id": false
    },
    "PY": {
        "code": "PY",
        "three_letter_code": "PRY",
        "name_de": "Paraguay",
        "name_en": "Paraguay",
        "postal_name_en": "Paraguay",
        "require_vat_id": false
    },
    "PE": {
        "code": "PE",
        "three_letter_code": "PER",
        "name_de": "Peru",
        "name_en": "Peru",
        "postal_name_en": "Peru",
        "require_vat_id": false
    },
    "PH": {
        "code": "PH",
        "three_letter_code": "PHL",
        "name_de": "Philippinen",
        "name_en": "Philippines",
        "postal_name_en": "Philippines",
        "require_vat_id": false
    },
    "PN": {
        "code": "PN",
        "three_letter_code": "PCN",
        "name_de": "Pitcairn",
        "name_en": "Pitcairn",
        "postal_name_en": "Pitcairn",
        "require_vat_id": false
    },
    "PL": {
        "code": "PL",
        "three_letter_code": "POL",
        "name_de": "Polen",
        "name_en": "Poland",
        "postal_name_en": "Poland",
        "require_vat_id": true
    },
    "PT": {
        "code": "PT",
        "three_letter_code": "PRT",
        "name_de": "Portugal",
        "name_en": "Portugal",
        "postal_name_en": "Portugal",
        "require_vat_id": true
    },
    "PR": {
        "code": "PR",
        "three_letter_code": "PRI",
        "name_de": "Puerto Rico",
        "name_en": "Puerto Rico",
        "postal_name_en": "Puerto Rico",
        "require_vat_id": false
    },
    "QA": {
        "code": "QA",
        "three_letter_code": "QAT",
        "name_de": "Katar",
        "name_en": "Qatar",
        "postal_name_en": "Qatar",
        "require_vat_id": false
    },
    "RE": {
        "code": "RE",
        "three_letter_code": "REU",
        "name_de": "Réunion",
        "name_en": "Réunion",
        "postal_name_en": "Réunion",
        "require_vat_id": false
    },
    "RO": {
        "code": "RO",
        "three_letter_code": "ROU",
        "name_de": "Rumänien",
        "name_en": "Romania",
        "postal_name_en": "Romania",
        "require_vat_id": true
    },
    "RU": {
        "code": "RU",
        "three_letter_code": "RUS",
        "name_de": "Russische Föderation",
        "name_en": "Russian Federation",
        "postal_name_en": "Russian Federation",
        "require_vat_id": false
    },
    "RW": {
        "code": "RW",
        "three_letter_code": "RWA",
        "name_de": "Ruanda",
        "name_en": "Rwanda",
        "postal_name_en": "Rwanda",
        "require_vat_id": false
    },
    "BL": {
        "code": "BL",
        "three_letter_code": "BLM",
        "name_de": "St. Barthélemy",
        "name_en": "Saint Barthélemy",
        "postal_name_en": "Saint Barthélemy",
        "require_vat_id": false
    },
    "SH": {
        "code": "SH",
        "three_letter_code": "SHN",
        "name_de": "Saint Helena",
        "name_en": "Saint Helena, Ascension and Tristan Da Cunha",
        "postal_name_en": "St. Helena",
        "require_vat_id": false
    },
    "KN": {
        "code": "KN",
        "three_letter_code": "KNA",
        "name_de": "St. Kitts und Nevis",
        "name_en": "Saint Kitts and Nevis",
        "postal_name_en": "St. Kitts und Nevis",
        "require_vat_id": false
    },
    "LC": {
        "code": "LC",
        "three_letter_code": "LCA",
        "name_de": "St. Lucia",
        "name_en": "Saint Lucia",
        "postal_name_en": "St. Lucia",
        "require_vat_id": false
    },
    "MF": {
        "code": "MF",
        "three_letter_code": "MAF",
        "name_de": "St. Martin",
        "name_en": "Saint Martin (French Part)",
        "postal_name_en": "Saint Martin (French Part)",
        "require_vat_id": false
    },
    "PM": {
        "code": "PM",
        "three_letter_code": "SPM",
        "name_de": "Saint Pierre und Miquelon",
        "name_en": "Saint Pierre and Miquelon",
        "postal_name_en": "St. Pierre und Miquelon",
        "require_vat_id": false
    },
    "VC": {
        "code": "VC",
        "three_letter_code": "VCT",
        "name_de": "St. Vincent und die Grenadinen",
        "name_en": "Saint Vincent and the Grenadines",
        "postal_name_en": "St. Vincent und die Grenadinen",
        "require_vat_id": false
    },
    "WS": {
        "code": "WS",
        "three_letter_code": "WSM",
        "name_de": "Samoa",
        "name_en": "Samoa",
        "postal_name_en": "Samoa",
        "require_vat_id": false
    },
    "SM": {
        "code": "SM",
        "three_letter_code": "SMR",
        "name_de": "San Marino",
        "name_en": "San Marino",
        "postal_name_en": "San Marino",
        "require_vat_id": false
    },
    "ST": {
        "code": "ST",
        "three_letter_code": "STP",
        "name_de": "São Tomé und Príncipe",
        "name_en": "Sao Tome and Principe",
        "postal_name_en": "Sao Tome und Principe",
        "require_vat_id": false
    },
    "SA": {
        "code": "SA",
        "three_letter_code": "SAU",
        "name_de": "Saudi-Arabien",
        "name_en": "Saudi Arabia",
        "postal_name_en": "Saudi Arabia",
        "require_vat_id": false
    },
    "SN": {
        "code": "SN",
        "three_letter_code": "SEN",
        "name_de": "Senegal",
        "name_en": "Senegal",
        "postal_name_en": "Senegal",
        "require_vat_id": false
    },
    "RS": {
        "code": "RS",
        "three_letter_code": "SRB",
        "name_de": "Serbien",
        "name_en": "Serbia",
        "postal_name_en": "Serbia",
        "require_vat_id": false
    },
    "SC": {
        "code": "SC",
        "three_letter_code": "SYC",
        "name_de": "Seychellen",
        "name_en": "Seychelles",
        "postal_name_en": "Seychelles",
        "require_vat_id": false
    },
    "SL": {
        "code": "SL",
        "three_letter_code": "SLE",
        "name_de": "Sierra Leone",
        "name_en": "Sierra Leone",
        "postal_name_en": "Sierra Leone",
        "require_vat_id": false
    },
    "SG": {
        "code": "SG",
        "three_letter_code": "SGP",
        "name_de": "Singapur",
        "name_en": "Singapore",
        "postal_name_en": "Singapore",
        "require_vat_id": false
    },
    "SX": {
        "code": "SX",
        "three_letter_code": "SXM",
        "name_de": "Sint Maarten",
        "name_en": "Sint Maarten (Dutch Part)",
        "postal_name_en": "Netherlands Antilles",
        "require_vat_id": false
    },
    "SK": {
        "code": "SK",
        "three_letter_code": "SVK",
        "name_de": "Slowakei",
        "name_en": "Slovakia",
        "postal_name_en": "Slovakia",
        "require_vat_id": true
    },
    "SI": {
        "code": "SI",
        "three_letter_code": "SVN",
        "name_de": "Slowenien",
        "name_en": "Slovenia",
        "postal_name_en": "Slovenia",
        "require_vat_id": true
    },
    "SB": {
        "code": "SB",
        "three_letter_code": "SLB",
        "name_de": "Salomonen",
        "name_en": "Solomon Islands",
        "postal_name_en": "Solomon Islands",
        "require_vat_id": false
    },
    "SO": {
        "code": "SO",
        "three_letter_code": "SOM",
        "name_de": "Somalia",
        "name_en": "Somalia",
        "postal_name_en": "Somalia",
        "require_vat_id": false
    },
    "ZA": {
        "code": "ZA",
        "three_letter_code": "ZAF",
        "name_de": "Südafrika",
        "name_en": "South Africa",
        "postal_name_en": "South Africa",
        "require_vat_id": false
    },
    "GS": {
        "code": "GS",
        "three_letter_code": "SGS",
        "name_de": "Südgeorgien und die Südlichen Sandwichinseln",
        "name_en": "South Georgia and the South Sandwich Islands",
        "postal_name_en": "South Georgia and the South Sandwich Islands",
        "require_vat_id": false
    },
    "SS": {
        "code": "SS",
        "three_letter_code": "SSD",
        "name_de": "Südsudan",
        "name_en": "South Sudan",
        "postal_name_en": "South Sudan",
        "require_vat_id": false
    },
    "ES": {
        "code": "ES",
        "three_letter_code": "ESP",
        "name_de": "Spanien",
        "name_en": "Spain",
        "postal_name_en": "Spain",
        "require_vat_id": true
    },
    "LK": {
        "code": "LK",
        "three_letter_code": "LKA",
        "name_de": "Sri Lanka",
        "name_en": "Sri Lanka",
        "postal_name_en": "Sri Lanka",
        "require_vat_id": false
    },
    "SD": {
        "code": "SD",
        "three_letter_code": "SDN",
        "name_de": "Sudan",
        "name_en": "Sudan",
        "postal_name_en": "Sudan",
        "require_vat_id": false
    },
    "SR": {
        "code": "SR",
        "three_letter_code": "SUR",
        "name_de": "Suriname",
        "name_en": "Suriname",
        "postal_name_en": "Suriname",
        "require_vat_id": false
    },
    "SJ": {
        "code": "SJ",
        "three_letter_code": "SJM",
        "name_de": "Svalbard und Jan Mayen",
        "name_en": "Svalbard and Jan Mayen",
        "postal_name_en": "Svalbard and Jan Mayen",
        "require_vat_id": false
    },
    "SZ": {
        "code": "SZ",
        "three_letter_code": "SWZ",
        "name_de": "Swasiland",
        "name_en": "Swaziland",
        "postal_name_en": "Swasiland",
        "require_vat_id": false
    },
    "SE": {
        "code": "SE",
        "three_letter_code": "SWE",
        "name_de": "Schweden",
        "name_en": "Sweden",
        "postal_name_en": "Sweden",
        "require_vat_id": true
    },
    "SY": {
        "code": "SY",
        "three_letter_code": "SYR",
        "name_de": "Syrien, Arab. Rep.",
        "name_en": "Syrian Arab Republic",
        "postal_name_en": "Syria",
        "require_vat_id": false
    },
    "TW": {
        "code": "TW",
        "three_letter_code": "TWN",
        "name_de": "Taiwan",
        "name_en": "Taiwan, Province of China",
        "postal_name_en": "Taiwan",
        "require_vat_id": false
    },
    "TJ": {
        "code": "TJ",
        "three_letter_code": "TJK",
        "name_de": "Tadschikistan",
        "name_en": "Tajikistan",
        "postal_name_en": "Tajikistan",
        "require_vat_id": false
    },
    "TZ": {
        "code": "TZ",
        "three_letter_code": "TZA",
        "name_de": "Tansania, Vereinigte Rep.",
        "name_en": "Tanzania, United Republic of",
        "postal_name_en": "Tanzania",
        "require_vat_id": false
    },
    "TH": {
        "code": "TH",
        "three_letter_code": "THA",
        "name_de": "Thailand",
        "name_en": "Thailand",
        "postal_name_en": "Thailand",
        "require_vat_id": false
    },
    "TL": {
        "code": "TL",
        "three_letter_code": "TLS",
        "name_de": "Timor-Leste",
        "name_en": "Timor-Leste",
        "postal_name_en": "Timor-Leste",
        "require_vat_id": false
    },
    "TG": {
        "code": "TG",
        "three_letter_code": "TGO",
        "name_de": "Togo",
        "name_en": "Togo",
        "postal_name_en": "Togo",
        "require_vat_id": false
    },
    "TK": {
        "code": "TK",
        "three_letter_code": "TKL",
        "name_de": "Tokelau",
        "name_en": "Tokelau",
        "postal_name_en": "Tokelau",
        "require_vat_id": false
    },
    "TO": {
        "code": "TO",
        "three_letter_code": "TON",
        "name_de": "Tonga",
        "name_en": "Tonga",
        "postal_name_en": "Tonga",
        "require_vat_id": false
    },
    "TT": {
        "code": "TT",
        "three_letter_code": "TTO",
        "name_de": "Trinidad und Tobago",
        "name_en": "Trinidad and Tobago",
        "postal_name_en": "Trinidad and Tobago",
        "require_vat_id": false
    },
    "TN": {
        "code": "TN",
        "three_letter_code": "TUN",
        "name_de": "Tunesien",
        "name_en": "Tunisia",
        "postal_name_en": "Tunisia",
        "require_vat_id": false
    },
    "TR": {
        "code": "TR",
        "three_letter_code": "TUR",
        "name_de": "Türkei",
        "name_en": "Turkey",
        "postal_name_en": "Turkey",
        "require_vat_id": false
    },
    "TM": {
        "code": "TM",
        "three_letter_code": "TKM",
        "name_de": "Turkmenistan",
        "name_en": "Turkmenistan",
        "postal_name_en": "Turkmenistan",
        "require_vat_id": false
    },
    "TC": {
        "code": "TC",
        "three_letter_code": "TCA",
        "name_de": "Turks- und Caicosinseln",
        "name_en": "Turks and Caicos Islands",
        "postal_name_en": "Turks- und Caicosinseln",
        "require_vat_id": false
    },
    "TV": {
        "code": "TV",
        "three_letter_code": "TUV",
        "name_de": "Tuvalu",
        "name_en": "Tuvalu",
        "postal_name_en": "Tuvalu",
        "require_vat_id": false
    },
    "UG": {
        "code": "UG",
        "three_letter_code": "UGA",
        "name_de": "Uganda",
        "name_en": "Uganda",
        "postal_name_en": "Uganda",
        "require_vat_id": false
    },
    "UA": {
        "code": "UA",
        "three_letter_code": "UKR",
        "name_de": "Ukraine",
        "name_en": "Ukraine",
        "postal_name_en": "Ukraine",
        "require_vat_id": false
    },
    "AE": {
        "code": "AE",
        "three_letter_code": "ARE",
        "name_de": "Vereinigte Arabische Emirate",
        "name_en": "United Arab Emirates",
        "postal_name_en": "United Arab Emirates",
        "require_vat_id": false
    },
    "GB": {
        "code": "GB",
        "three_letter_code": "GBR",
        "name_de": "Vereinigtes Königreich",
        "name_en": "United Kingdom",
        "postal_name_en": "United Kingdom",
        "require_vat_id": true
    },
    "XI": {
        "code": "XI",
        "three_letter_code": null,
        "name_de": "Vereinigtes Königreich (Nordirland)",
        "name_en": "United Kingdom (Northern Ireland)",
        "postal_name_en": "Northern Ireland",
        "require_vat_id": true
    },
    "US": {
        "code": "US",
        "three_letter_code": "USA",
        "name_de": "Vereinigte Staaten von Amerika",
        "name_en": "United States",
        "postal_name_en": "United States",
        "require_vat_id": false
    },
    "UM": {
        "code": "UM",
        "three_letter_code": "UMI",
        "name_de": "United States Minor Outlying Islands",
        "name_en": "United States Minor Outlying Islands",
        "postal_name_en": "United States Minor Outlying Islands",
        "require_vat_id": false
    },
    "UY": {
        "code": "UY",
        "three_letter_code": "URY",
        "name_de": "Uruguay",
        "name_en": "Uruguay",
        "postal_name_en": "Uruguay",
        "require_vat_id": false
    },
    "UZ": {
        "code": "UZ",
        "three_letter_code": "UZB",
        "name_de": "Usbekistan",
        "name_en": "Uzbekistan",
        "postal_name_en": "Uzbekistan",
        "require_vat_id": false
    },
    "VU": {
        "code": "VU",
        "three_letter_code": "VUT",
        "name_de": "Vanuatu",
        "name_en": "Vanuatu",
        "postal_name_en": "Vanuatu",
        "require_vat_id": false
    },
    "VE": {
        "code": "VE",
        "three_letter_code": "VEN",
        "name_de": "Venezuela",
        "name_en": "Venezuela, Bolivarian Republic of",
        "postal_name_en": "Venezuela",
        "require_vat_id": false
    },
    "VN": {
        "code": "VN",
        "three_letter_code": "VNM",
        "name_de": "Vietnam",
        "name_en": "Viet Nam",
        "postal_name_en": "Viet Nam",
        "require_vat_id": false
    },
    "VG": {
        "code": "VG",
        "three_letter_code": "VGB",
        "name_de": "Britische Jungferninseln",
        "name_en": "Virgin Islands, British",
        "postal_name_en": "British Virgin Islands",
        "require_vat_id": false
    },
    "VI": {
        "code": "VI",
        "three_letter_code": "VIR",
        "name_de": "Amerikanische Jungferninseln",
        "name_en": "Virgin Islands, U.S.",
        "postal_name_en": "Jungferninseln",
        "require_vat_id": false
    },
    "WF": {
        "code": "WF",
        "three_letter_code": "WLF",
        "name_de": "Wallis und Futuna",
        "name_en": "Wallis and Futuna",
        "postal_name_en": "Wallis und Futuna",
        "require_vat_id": false
    },
    "EH": {
        "code": "EH",
        "three_letter_code": "ESH",
        "name_de": "Westsahara",
        "name_en": "Western Sahara",
        "postal_name_en": "Western Sahara",
        "require_vat_id": false
    },
    "YE": {
        "code": "YE",
        "three_letter_code": "YEM",
        "name_de": "Jemen",
        "name_en": "Yemen",
        "postal_name_en": "Yemen",
        "require_vat_id": false
    },
    "ZM": {
        "code": "ZM",
        "three_letter_code": "ZMB",
        "name_de": "Sambia",
        "name_en": "Zambia",
        "postal_name_en": "Zambia",
        "require_vat_id": false
    },
    "ZW": {
        "code": "ZW",
        "three_letter_code": "ZWE",
        "name_de": "Simbabwe",
        "name_en": "Zimbabwe",
        "postal_name_en": "Zimbabwe",
        "require_vat_id": false
    }
}

export function getLabelForCountryCode(countries, code) {
    if (!countries) {
        return null;
    }

    for (let i = 0; i < countries.length; i++) {
        if (countries[i].code[1].code === code) {
            return countries[i].code.name_de;
        }
    }

    return null;
}

export const VATID_PLACEHOLDERS = {
    'AT': 'ATU99999999',
    'CH': 'CHE-999.999.999',
    'BE': 'BE0999999999',
    'BG': 'BG999999999',
    'CY': 'CY99999999L',
    'CZ': 'CZ99999999',
    'DK': 'DK99 99 99 99',
    'EE': 'EE999999999',
    'EL': 'EL999999999',
    'ES': 'ESX9999999X4',
    'FI': 'FI99999999',
    'FR': 'FRXX 999999999',
    'HR': 'HR99999999999',
    'HU': 'HU99999999',
    'IE': 'IE9S99999L',
    'IT': 'IT99999999999',
    'LT': 'LT999999999',
    'LU': 'LU99999999',
    'LV': 'LV99999999999',
    'MT': 'MT99999999',
    'NL': 'NLXXXXXXXXXXXX',
    'PL': 'PL9999999999',
    'PT': 'PT999999999',
    'RO': 'RO999999999',
    'SE': 'SE999999999999',
    'SI': 'SI99999999',
    'SK': 'SK9999999999',
    'XI': 'XI999 9999 99 9995',
    'GB': 'GB999 9999 73',
    'IS': 'IS999999',
    'NO': 'NO999999999',
}

export function getVatIdPlaceholder(countryCode) {
    if (!countryCode) {
        return null;
    }

    if (VATID_PLACEHOLDERS.hasOwnProperty(countryCode.toUpperCase())) {
        return VATID_PLACEHOLDERS[countryCode.toUpperCase()];
    }

    return null;
}
